import naja from 'naja';

export class OrdersTableFilter {
    private searchInput: HTMLInputElement | null;
    private tableRows: NodeListOf<HTMLTableRowElement>;
    private orderNumbers: string[] = [];

    constructor() {
        this.searchInput = document.querySelector('.person-order-block__search input');
        this.tableRows = document.querySelectorAll('.person-order-table tbody tr');
        
        if (this.searchInput && this.tableRows.length > 0) {
            this.collectOrderNumbers();
            this.initializeFilter();
            this.setupNajaHandler();
        }
    }

    private collectOrderNumbers(): void {
        this.tableRows.forEach((row) => {
            const orderNumberCell = row.querySelector('td:first-child');
            if (orderNumberCell) {
                const orderNumber = orderNumberCell.textContent?.trim() || '';
                this.orderNumbers.push(orderNumber.toLowerCase());
            }
        });
    }

    private initializeFilter(): void {
        if (!this.searchInput) return;

        this.searchInput.addEventListener('input', (event) => {
            const target = event.target as HTMLInputElement;
            const searchValue = target.value.toLowerCase().trim();
            
            this.tableRows.forEach((row, index) => {
                const orderNumber = this.orderNumbers[index];
                const isVisible = orderNumber.includes(searchValue);
                row.style.display = isVisible ? '' : 'none';
            });
        });
    }

    private setupNajaHandler(): void {
        naja.snippetHandler.addEventListener('afterUpdate', (event: { detail: { snippet: { id: string } } }) => {
            if (event.detail.snippet.id === 'snippet-ordersTable') {
                this.searchInput = document.querySelector('.person-order-block__search input');
                this.tableRows = document.querySelectorAll('.person-order-table tbody tr');
                this.orderNumbers = [];
                
                if (this.searchInput && this.tableRows.length > 0) {
                    this.collectOrderNumbers();
                    this.initializeFilter();
                }
            }
        });
    }
}

export default OrdersTableFilter;